import { Storefront } from "./storefront/Storefront";
import { Kueche } from "./kueche/Kueche";
import { navigiere, usePfad } from "./router";

/** Die Wurzel: Kopfzeile plus Weiche zwischen Kundenladen und Küchen-Dashboard. */
export function App() {
  const pfad = usePfad();
  const inKueche = pfad.startsWith("/kueche");

  return (
    <div className="huelle">
      <header className="kopf">
        <button className="marke" onClick={() => navigiere("/")} type="button">
          Pizza Paten
        </button>
        <nav className="kopf-nav">
          <a
            href="/"
            className={inKueche ? "" : "aktiv"}
            onClick={(e) => {
              e.preventDefault();
              navigiere("/");
            }}
          >
            Speisekarte
          </a>
          <a
            href="/kueche"
            className={inKueche ? "aktiv" : ""}
            onClick={(e) => {
              e.preventDefault();
              navigiere("/kueche");
            }}
          >
            Küche
          </a>
        </nav>
      </header>
      <main className="inhalt">{inKueche ? <Kueche /> : <Storefront />}</main>
    </div>
  );
}
